var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "group",
      class: { "is-first-item": _vm.isFirstItem },
      on: {
        contextmenu: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.openContextMenu($event)
        },
      },
    },
    [
      _c("div", {
        staticClass: "splitter",
        class: { visible: _vm.isDraggingOverTop },
      }),
      !_vm.isRenaming
        ? _c(
            "div",
            {
              staticClass: "group-name",
              class: { "drag-inside": _vm.isDraggingInside },
              attrs: { draggable: _vm.isDraggable },
              on: {
                drop: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.onDrop($event)
                },
                dragover: function ($event) {
                  return _vm.onDragOver($event)
                },
                dragstart: function ($event) {
                  return _vm.onDragStart($event)
                },
                dragexit: function ($event) {
                  return _vm.onDragLeave($event)
                },
              },
            },
            [
              _c("w-fa", { staticClass: "mr", attrs: { icon: "folder" } }),
              _vm._v(_vm._s(_vm.value.Name) + " "),
              _c("w-spacer"),
              _vm.canAddSubGroup
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("new-product-group"),
                          expression: "$ct('new-product-group')",
                        },
                      ],
                      staticClass: "action",
                      attrs: { disabled: !_vm.canEdit, flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.createNewGroup()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("rename-product-group"),
                      expression: "$ct('rename-product-group')",
                    },
                  ],
                  staticClass: "action",
                  attrs: { disabled: !_vm.canEdit, flat: "" },
                  on: {
                    click: function ($event) {
                      return _vm.rename()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("edit-product-group-properties"),
                      expression: "$ct('edit-product-group-properties')",
                    },
                  ],
                  staticClass: "action",
                  attrs: { disabled: !_vm.canEdit, flat: "" },
                  on: {
                    click: function ($event) {
                      _vm.editPropertiesOpened = true
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "cog" } })],
                1
              ),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.delete"),
                      expression: "$ct('common.delete')",
                    },
                  ],
                  staticClass: "action",
                  attrs: { disabled: !_vm.canEdit, flat: "" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteSelf()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          )
        : _c("w-input", {
            ref: "renameInput",
            on: {
              blur: function ($event) {
                return _vm.onRenameBlur()
              },
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  $event.stopPropagation()
                  return _vm.onRenameEscape()
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onRenameBlur()
                },
              ],
            },
            model: {
              value: _vm.newName,
              callback: function ($$v) {
                _vm.newName = $$v
              },
              expression: "newName",
            },
          }),
      _c(
        "transition-group",
        { attrs: { tag: "div", name: "fade" } },
        _vm._l(_vm.value.Children, function (val, i) {
          return _c("app-product-group-edit-node", {
            key: val.getUid(),
            staticClass: "child",
            attrs: { value: val, path: `${_vm.path}/${i}` },
            on: {
              remove: function ($event) {
                return _vm.deleteGroup(val)
              },
              move: _vm.propagateMove,
            },
          })
        }),
        1
      ),
      _c("div", {
        staticClass: "splitter",
        class: { visible: _vm.isDraggingOverBottom },
      }),
      _vm.canEdit && _vm.contextMenuOpened
        ? _c("app-context-menu", {
            attrs: {
              x: _vm.contextMenuX,
              y: _vm.contextMenuY,
              "can-add-sub-group": _vm.canAddSubGroup,
              "group-selected": "",
            },
            on: {
              new: function ($event) {
                return _vm.createNewGroup()
              },
              delete: function ($event) {
                return _vm.deleteSelf()
              },
              rename: function ($event) {
                return _vm.rename()
              },
              "edit-properties": function ($event) {
                _vm.editPropertiesOpened = true
              },
            },
            model: {
              value: _vm.contextMenuOpened,
              callback: function ($$v) {
                _vm.contextMenuOpened = $$v
              },
              expression: "contextMenuOpened",
            },
          })
        : _vm._e(),
      _c(
        "w-modal",
        {
          staticClass: "modal",
          attrs: { value: _vm.editPropertiesOpened },
          nativeOn: {
            contextmenu: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _vm.editPropertiesOpened
            ? _c("app-product-group-edit-properties", {
                on: {
                  close: function ($event) {
                    _vm.editPropertiesOpened = false
                  },
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }